<template>
  <div class="CardConfig-page" ref="container">
		<div class="info-content">
			<div class="info-box">
				<div class="info-box-content">
					<div class="info-box-label">
						<div class="label-name">银行卡号</div>
						<div class="label-value"><input type="input" v-model="info.bankNo" placeholder="请填写银行卡号"/></div>
					</div>
					<div class="info-box-label">
						<div class="label-name">开户姓名</div>
						<div class="label-value"><input type="input" v-model="info.bankUser" placeholder="请填写开户姓名"/></div>
					</div>
					<div class="info-box-label">
						<div class="label-name">开户行</div>
						<div class="label-value"><input type="input" v-model="info.bankName" placeholder="请填写开户行"/></div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="btnView">
			<div class="btn btn-logout" @click="logout">退出登录</div>
			<div class="btn btn-save" @click="save">保存</div>
		</div>
		
	</div>
</template>
<script>
import PetApi from "../../api/petAdmin";
export default {
  name: "PetAdminCardConfig",
  components: {},
  props: {},
  data: function() {
    return {
			info : {
				bankNo : '',
				bankUser : '',
				bankName : ''
			},
    };
  },
  watch: {
    $route(n) {
      if (n.name === 'PetAdminCardConfig') {
    		let prevPage = this.$prevRoute();
    		if (prevPage && prevPage.name == "PetAdmin") {
    			this.getInfo();
    		}
      }
    }
  },
  mounted: function() {
		this.getInfo();
  },
  computed: {},
  methods: {
		logout: function() {
		  this.$dialog.confirm({
		    mes: "确认退出登录?",
		    opts: () => {
		      PetApi.logout()
		        .then(res => {
		          this.$store.commit("PETLOGOUT");
		          location.href = location.origin + "/petAdmin/login";
		        })
		        .catch(err => {
		          console.log(err);
		        });
		    }
		  });
		},
		save() {
			let that = this;
			PetApi.petSetBankCard(this.info).then(
			  res => {
					that.$dialog.message(res.msg);
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		},
		getInfo() {
			let that = this;
			PetApi.petBankCard().then(
			  res => {
					that.info = res.data;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		},
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.page-wrap {}
.CardConfig-page {
	
	.info-content {
		padding: 0 0.32rem;
		.info-box {
			background: #FFFFFF;
			border-radius: .20rem;
			margin-top: 0.48rem;
			position: relative;
	
			.info-box-content {
				padding: 0 0.3rem;
				
				.info-box-label {
					display: flex;
					justify-content: space-between;
					height: 1rem;
					align-items: center;
					
					&:not(:last-child) {
						border-bottom: 0.02rem solid #E8E8E8;
					}
					
					
					.label-name {
						font-weight: 400;
						font-size: .28rem;
						color: #000000;
						width: 1.5rem;
					}
					.label-value {
						font-weight: 400;
						font-size: .28rem;
						color: #999999;
						text-align: left;
						flex: 1;
					}
					
					.iconfont {
						font-weight: 600;
						font-size: 0.28rem;
						margin-left: 0.12rem;
						color: #888888;;
					}
				}
			}
		}
	}
	
	.btnView {
		width: 100%;
		position: fixed;
		bottom : 1rem;
		padding: 0 0.32rem;
		display: flex;
		justify-content: space-between;
		.btn {
			height: 1rem;
			line-height: 1rem;
			border-radius: .50rem;
			text-align: center;
			font-weight: 400;
			font-size: .34rem;
			
			&.btn-save {
				background: #F5A100;
				color : #fff;
				flex : 1;
			}
			&.btn-logout {
				border: 0.02rem solid #F5A100;
				color: #F5A100;
				width: 30%;
				margin-right: 0.2rem;
			}
		}
	}
}

</style>
